"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchMessageUrl = exports.initializeProfileCard = exports.hideProfile = exports.toggleProfile = void 0;

var _axios = _interopRequireDefault(require("axios"));

var R = _interopRequireWildcard(require("ramda"));

var _localization = _interopRequireDefault(require("../localization"));

var _actionTypes = _interopRequireDefault(require("./action-types"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var toggleProfile = function toggleProfile(id, profileCardId) {
  return function (dispatch, getState) {
    if (getState()[profileCardId].isOpen) {
      dispatch(hideProfile(profileCardId));
    } else {
      dispatch(fetchProfile(id, profileCardId));
      dispatch(fetchMessageUrl(id, profileCardId));
    }
  };
};

exports.toggleProfile = toggleProfile;

var fetchProfile = function fetchProfile(id, profileCardId) {
  return function (dispatch) {
    dispatch(showProfile(profileCardId));
    return _axios.default.get("/api/people/".concat(id, ".json")).then(function (response) {
      dispatch(profileFetched(profileCardId, id, response.data.data.attributes, response.data.data.links.avatar));
    }).catch(function () {
      dispatch(profileFetchedError(profileCardId));
    });
  };
};

var profileFetched = function profileFetched(profileCardId, id, details, avatarUrl) {
  return {
    type: _actionTypes.default.PROFILE_FETCHED,
    payload: {
      profileCardId: profileCardId,
      id: id,
      name: details.name,
      company: details.company,
      title: details.title,
      level: details.level,
      avatarUrl: avatarUrl
    }
  };
};

var showProfile = function showProfile(profileCardId) {
  return {
    type: _actionTypes.default.SHOW_PROFILE,
    payload: {
      profileCardId: profileCardId
    }
  };
};

var hideProfile = function hideProfile(profileCardId) {
  return {
    type: _actionTypes.default.HIDE_PROFILE,
    payload: {
      profileCardId: profileCardId
    }
  };
};

exports.hideProfile = hideProfile;

var profileFetchedError = function profileFetchedError(profileCardId) {
  return {
    type: _actionTypes.default.PROFILE_ERROR,
    payload: {
      profileCardId: profileCardId,
      errorMsg: _localization.default.t('Profile details could not be loaded.')
    }
  };
};

var initializeProfileCard = function initializeProfileCard(profileCardId) {
  return {
    type: _actionTypes.default.INITIALIZE_CARD,
    payload: {
      profileCardId: profileCardId
    }
  };
};

exports.initializeProfileCard = initializeProfileCard;

var fetchMessageUrl = function fetchMessageUrl(memberId, profileCardId) {
  return function (dispatch) {
    return _axios.default.get('/api/features/public').then(R.path(['data', 'data'])).then(R.pipe(function (features) {
      return features.includes('inbox_v2') ? "/chat?p=".concat(memberId) : "/inbox/".concat(memberId);
    }, function (messageUrl) {
      return dispatch({
        type: _actionTypes.default.SET_MESSAGE_URL,
        payload: {
          messageUrl: messageUrl,
          profileCardId: profileCardId
        }
      });
    })).catch(function () {
      return dispatch({
        type: _actionTypes.default.SET_MESSAGE_URL,
        payload: {
          messageUrl: "/inbox/".concat(memberId),
          profileCardId: profileCardId
        }
      });
    });
  };
};

exports.fetchMessageUrl = fetchMessageUrl;